import React, { useState, useRef, useEffect } from "react";
import Swal from "sweetalert2";
import "./style.css";
import PropTypes from "prop-types";

function PatternLock({ onPatternComplete }) {
  const [pattern, setPattern] = useState([]);
  const [firstPattern, setFirstPattern] = useState(null);
  const [isSecondPattern, setIsSecondPattern] = useState(false);
  const [drawing, setDrawing] = useState(false);
  const points = useRef([]);
  const canvasRef = useRef(null);

  const getPointIndex = (x, y) => {
    const pointSize = 20;
    for (let i = 0; i < 9; i += 1) {
      const col = i % 3;
      const row = Math.floor(i / 3);
      const pointX = col * 100 + 50;
      const pointY = row * 100 + 50;

      if (
        x >= pointX - pointSize &&
        x <= pointX + pointSize &&
        y >= pointY - pointSize &&
        y <= pointY + pointSize
      ) {
        return i + 1;
      }
    }
    return null;
  };

  const drawPattern = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const pointss = [];
    for (let i = 0; i < 9; i += 1) {
      const col = i % 3;
      const row = Math.floor(i / 3);
      const pointX = col * 100 + 50;
      const pointY = row * 100 + 50;
      pointss.push({ x: pointX, y: pointY });

      // Vẽ các điểm
      ctx.beginPath();
      ctx.arc(pointX, pointY, 10, 0, Math.PI * 2);
      ctx.fillStyle = "#fff";
      ctx.fill();
      ctx.strokeStyle = "#000";
      ctx.stroke();
    }

    // Vẽ các đường kết nối
    if (pattern.length > 0) {
      ctx.beginPath();
      ctx.moveTo(pointss[pattern[0] - 1].x, pointss[pattern[0] - 1].y);
      for (let i = 1; i < pattern.length; i += 1) {
        ctx.lineTo(pointss[pattern[i] - 1].x, pointss[pattern[i] - 1].y);
      }
      ctx.strokeStyle = "#00f";
      ctx.lineWidth = 4;
      ctx.stroke();
    }
  };

  useEffect(() => {
    drawPattern();
  }, [pattern]);

  const handleMouseDown = (e) => {
    setDrawing(true);
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const pointIndex = getPointIndex(x, y);

    if (pointIndex !== null) {
      points.current = [pointIndex];
      setPattern([pointIndex]);
    }
  };

  const handleMouseMove = (e) => {
    if (drawing) {
      const canvas = canvasRef.current;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const pointIndex = getPointIndex(x, y);

      if (pointIndex !== null && !points.current.includes(pointIndex)) {
        points.current.push(pointIndex);
        setPattern([...points.current]);
      }
    }
  };

  const handleMouseUp = () => {
    if (drawing) {
      setDrawing(false);
      if (!isSecondPattern) {
        setFirstPattern(pattern);
        setIsSecondPattern(true);
        Swal.fire({
          title: "Nhập lại mẫu hình",
          text: "Vẽ lại mẫu hình để xác nhận",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        if (JSON.stringify(firstPattern) === JSON.stringify(pattern)) {
          if (onPatternComplete) {
            onPatternComplete(pattern);
          }
        } else {
          Swal.fire({
            title: "Mẫu hình không khớp",
            text: "Mẫu hình không khớp. Vui lòng thử lại mẫu hình mới",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
        setFirstPattern(null);
        setIsSecondPattern(false);
      }
      points.current = [];
      setPattern([]);
    }
  };

  const handleTouchStart = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches[0];
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top + 20;
    const pointIndex = getPointIndex(x, y);

    if (pointIndex !== null) {
      points.current = [pointIndex];
      setPattern([pointIndex]);
    }
  };

  const handleTouchMove = (e) => {
    if (points.current.length > 0) {
      const canvas = canvasRef.current;
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0];
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top + 20;
      const pointIndex = getPointIndex(x, y);

      if (pointIndex !== null && !points.current.includes(pointIndex)) {
        points.current.push(pointIndex);
        setPattern([...points.current]);
      }
    }
  };

  const handleTouchEnd = () => {
    points.current = [];
    if (pattern.length > 1) {
      onPatternComplete(pattern);
    }
    setTimeout(() => {
      setPattern([]);
    }, 1000);
  };

  return (
    <div className="pattern-lock">
      <canvas
        style={{ border: "1px solid #4c524e", backgroundColor: "#4c524e" }}
        ref={canvasRef}
        width="300"
        height="300"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        // onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      />
    </div>
  );
}

PatternLock.propTypes = {
  onPatternComplete: PropTypes.func.isRequired,
};

export default PatternLock;
